// import React, { useEffect, useRef } from "react";
// import {
//   FaUniversity,
//   FaBitcoin,
//   FaShoppingCart,
//   FaHeartbeat,
//   FaHome,
//   FaTruck,
//   FaGraduationCap,
//   FaGamepad,
// } from "react-icons/fa";

// const industries = [
//   { title: "Fintech & Banking", icon: <FaUniversity /> },
//   { title: "Crypto & Web3", icon: <FaBitcoin /> },
//   { title: "E-commerce & Retail", icon: <FaShoppingCart /> },
//   { title: "Healthcare", icon: <FaHeartbeat /> },
//   { title: "Real Estate", icon: <FaHome /> },
//   { title: "Logistics & Supply Chain", icon: <FaTruck /> },
//   { title: "Education & EdTech", icon: <FaGraduationCap /> },
//   { title: "Gaming & Metaverse", icon: <FaGamepad /> },
// ];

// export default function Technologies() {
//   return (
//     <section className="technologies-area default-padding">
//       <div className="container">
//         <div className="row align-items-center">
//           {/* LEFT */}
//           <div className="col-lg-5 mb-4 mb-lg-0">
//             <h4 className="sub-title">INDUSTRIES WE SERVE</h4>
//             <h2 className="title">
//               Diversified Services <br /> for Every Industry
//             </h2>
//           </div>

//           {/* RIGHT */}
//           <div className="col-lg-7">
//             <div className="grid-wrapper">
//               <Column direction="up" speed={0.8} />
//               <Column direction="down" speed={0.8} />
//               <Column direction="up" speed={0.8} />
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* STYLES */}
//       <style>{`
//         .grid-wrapper {
//           display: flex;
//           gap: 20px;
//           height: 480px;
//         }

//         /* TABLET */
//         @media (max-width: 991px) {
//           .grid-wrapper {
//             height: 420px;
//           }
//         }

//         /* MOBILE */
//         @media (max-width: 767px) {
//           .grid-wrapper {
//             flex-direction: column;
//             height: auto;
//           }
//         }

//         .industry-card {
//           background: #fff;
//           border-radius: 16px;
//           padding: 18px;
//           margin-bottom: 15px;
//           text-align: center;
//           border: 1px solid #e2e8f0;
//           transition: all 0.3s ease;
//         }

//         .industry-card:hover {
//           transform: translateY(-6px);
//           box-shadow: 0 15px 30px rgba(0,0,0,0.08);
//         }

//         .industry-icon {
//           width: 55px;
//           height: 55px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           margin: 0 auto 10px;
//           background: rgba(59,130,246,0.1);
//           color: #3b82f6;
//           border-radius: 12px;
//           font-size: 22px;
//         }

//         .industry-card:hover .industry-icon {
//           background: #3b82f6;
//           color: #fff;
//         }

//         h5 {
//           font-size: 14px;
//           font-weight: 600;
//           margin: 0;
//         }
//       `}</style>
//     </section>
//   );
// }

// function Column({ direction = "up", speed = 1 }) {
//   const trackRef = useRef(null);
//   const position = useRef(0);
//   const currentSpeed = useRef(direction === "up" ? speed : -speed);
//   const targetSpeed = useRef(direction === "up" ? speed : -speed);

//   useEffect(() => {
//     let frame;

//     const animate = () => {
//       currentSpeed.current +=
//         (targetSpeed.current - currentSpeed.current) * 0.05;

//       position.current -= currentSpeed.current;

//       const track = trackRef.current;
//       if (track) {
//         const height = track.scrollHeight / 2;

//         if (direction === "up") {
//           if (position.current <= -height) {
//             position.current += height;
//           }
//         } else {
//           if (position.current >= 0) {
//             position.current -= height;
//           }
//         }

//         track.style.transform = `translateY(${position.current}px)`;
//       }

//       frame = requestAnimationFrame(animate);
//     };

//     frame = requestAnimationFrame(animate);
//     return () => cancelAnimationFrame(frame);
//   }, [direction]);

//   const handleEnter = () => {
//     targetSpeed.current = direction === "up" ? 0.2 : -0.2;
//   };

//   const handleLeave = () => {
//     targetSpeed.current = direction === "up" ? speed : -speed;
//   };

//   return (
//     <div
//       className="column"
//       onMouseEnter={handleEnter}
//       onMouseLeave={handleLeave}
//     >
//       <div ref={trackRef}>
//         {[...industries, ...industries].map((item, i) => (
//           <div className="industry-card" key={i}>
//             <div className="industry-icon">{item.icon}</div>
//             <h5>{item.title}</h5>
//           </div>
//         ))}
//       </div>

//       <style>{`
//         .column {
//           flex: 1;
//           overflow: hidden;
//           min-width: 0;
//           -webkit-mask-image: linear-gradient(to bottom, transparent, black 15%, black 85%, transparent);
//           mask-image: linear-gradient(to bottom, transparent, black 15%, black 85%, transparent);
//         }

//         /* MOBILE FIX */
//         @media (max-width: 767px) {
//           .column {
//             overflow-x: auto;
//             overflow-y: hidden;
//             display: flex;
//           }

//           .column > div {
//             display: flex;
//             gap: 15px;
//             transform: none !important;
//           }

//           .industry-card {
//             min-width: 180px;
//             margin-bottom: 0;
//           }
//         }
//       `}</style>
//     </div>
//   );
// }

import React, { useEffect, useRef } from "react";
import {
  FaUniversity,
  FaBitcoin,
  FaShoppingCart,
  FaHeartbeat,
  FaHome,
  FaTruck,
  FaGraduationCap,
  FaGamepad,
} from "react-icons/fa";

const industries = [
  { title: "Fintech & Banking", icon: <FaUniversity /> },
  { title: "Crypto & Web3", icon: <FaBitcoin /> },
  { title: "E-commerce & Retail", icon: <FaShoppingCart /> },
  { title: "Healthcare", icon: <FaHeartbeat /> },
  { title: "Real Estate", icon: <FaHome /> },
  { title: "Logistics & Supply Chain", icon: <FaTruck /> },
  { title: "Education & EdTech", icon: <FaGraduationCap /> },
  { title: "Gaming & Metaverse", icon: <FaGamepad /> },
];

export default function Technologies() {
  return (
    <section className="technologies-area default-padding">
      <div className="container">
        <div className="row align-items-center">
          {/* LEFT */}
          <div className="col-lg-5 mb-4 mb-lg-0">
            <h4 className="sub-title">INDUSTRIES WE SERVE</h4>
            <h2 className="title">
              Diversified Services <br /> for Every Industry
            </h2>
          </div>

          {/* RIGHT */}
          <div className="col-lg-7">
            <div className="grid-wrapper">
              <Column direction="up" speed={0.6} offset={0} />
              <Column direction="down" speed={0.9} offset={3} />
              <Column direction="up" speed={0.7} offset={5} />
            </div>
          </div>
        </div>
      </div>

      {/* STYLES */}
      <style>{`
        .grid-wrapper {
          display: flex;
          gap: 20px;
          height: 480px;
        }

        @media (max-width: 991px) {
          .grid-wrapper {
            height: 420px;
          }
        }

        @media (max-width: 767px) {
          .grid-wrapper {
            flex-direction: column;
            height: auto;
          }
        }

        .industry-card {
          background: #fff;
          border-radius: 16px;
          padding: 18px;
          margin-bottom: 15px;
          text-align: center;
          border: 1px solid #e2e8f0;
          transition: all 0.3s ease;
        }

        .industry-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 15px 30px rgba(0,0,0,0.08);
        }

        .industry-icon {
          width: 55px;
          height: 55px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 10px;
          background: rgba(59,130,246,0.1);
          color: #3b82f6;
          border-radius: 12px;
          font-size: 22px;
        }

        .industry-card:hover .industry-icon {
          background: #3b82f6;
          color: #fff;
        }

        h5 {
          font-size: 14px;
          font-weight: 600;
          margin: 0;
        }
      `}</style>
    </section>
  );
}

function Column({ direction = "up", speed = 1, offset = 0 }) {
  const trackRef = useRef(null);
  const position = useRef(0);
  const currentSpeed = useRef(direction === "up" ? speed : -speed);
  const targetSpeed = useRef(direction === "up" ? speed : -speed);

  // 🔥 SHIFT DATA (MAIN FIX)
  const shiftedIndustries = [
    ...industries.slice(offset),
    ...industries.slice(0, offset),
  ];

  useEffect(() => {
    let frame;

    const animate = () => {
      currentSpeed.current +=
        (targetSpeed.current - currentSpeed.current) * 0.05;

      position.current -= currentSpeed.current;

      const track = trackRef.current;
      if (track) {
        const height = track.scrollHeight / 2;

        if (direction === "up") {
          if (position.current <= -height) {
            position.current += height;
          }
        } else {
          if (position.current >= 0) {
            position.current -= height;
          }
        }

        track.style.transform = `translateY(${position.current}px)`;
      }

      frame = requestAnimationFrame(animate);
    };

    frame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame);
  }, [direction]);

  const handleEnter = () => {
    targetSpeed.current = direction === "up" ? 0.2 : -0.2;
  };

  const handleLeave = () => {
    targetSpeed.current = direction === "up" ? speed : -speed;
  };

  return (
    <div
      className="column"
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
    >
      <div ref={trackRef}>
        {[...shiftedIndustries, ...shiftedIndustries].map((item, i) => (
          <div className="industry-card" key={i}>
            <div className="industry-icon">{item.icon}</div>
            <h5>{item.title}</h5>
          </div>
        ))}
      </div>

      <style>{`
        .column {
          flex: 1;
          overflow: hidden;
          min-width: 0;
          -webkit-mask-image: linear-gradient(to bottom, transparent, black 15%, black 85%, transparent);
          mask-image: linear-gradient(to bottom, transparent, black 15%, black 85%, transparent);
        }

        @media (max-width: 767px) {
          .column {
            overflow-x: auto;
            overflow-y: hidden;
            display: flex;
          }

          .column > div {
            display: flex;
            gap: 15px;
            transform: none !important;
          }

          .industry-card {
            min-width: 180px;
            margin-bottom: 0;
          }
        }
      `}</style>
    </div>
  );
}
